"use strict";

import {VToast} from '@/components/toast.js';

window.generateStarRating = function (rating) {
    let html = '';

    for (let i = 1; i <= 5; i++) {
        if (rating > 0) {
            if (rating > 1) {
                html += '<i class="vi-icon vi-star"></i>';
            } else if (rating > 0.5) {
                html += '<i class="vi-icon vi-star-half"></i>';
            } else {
                html += '<i class="vi-icon vi-star-inactive"></i>';
            }
        } else {
            html += '<i class="vi-icon vi-star-inactive"></i>';
        }

        rating--;
    }

    return html;
}

window.shortNumber = function (num) {
    if (num < 1e3) return num;
    if (num >= 1e3 && num < 1e6) return +(num / 1e3).toFixed(1) + "K";
    if (num >= 1e6 && num < 1e9) return +(num / 1e6).toFixed(1) + "M";
    if (num >= 1e9 && num < 1e12) return +(num / 1e9).toFixed(1) + "B";
    if (num >= 1e12) return +(num / 1e12).toFixed(1) + "T";
}

window.getErrMsg = function (error) {
    let errMsg = '';
    
    if (error.response) {
        const response = error.response;

        if (response.status === 422) {
            if (response.data.error) {
                errMsg = response.data.error.join("<br/>");
            } else if (response.data.errors) {
                errMsg = Object.values(response.data.errors).map(function (item) {
                    return Object.values(item).join('<br/>');
                });
            } else {
                errMsg = response.data.message
            }
        } else {
            errMsg = response.data.message;
        }
    } else {
        errMsg = error;
    }

    return errMsg;
}

window.showSuccessAlert = function (message) {
    const options = {
        title: 'Yay!!',
        text: message,
        bgCls: 'bg-success'
    };

    new VToast(options).fire();
}

window.showErrorAlert = function (message) {
    const options = {
        title: 'Uh-Oh!!',
        text: message,
        bgCls: 'bg-danger'
    };

    new VToast(options).fire();
}

window.btnStartAnimation = function (targetEl, label = 'Processing...') {
    targetEl.innerText = label;
    targetEl.disabled = true;
}

window.btnStopAnimation = function (targetEl, label) {
    targetEl.innerText = label;
    targetEl.disabled = false;
}

/* Bootstrap Toasts */
if (typeof msgText !== 'undefined' && msgText !== '') {
    window.onload = (event) => {
        const options = {
            title: msgTitle,
            text: msgText,
            bgCls: msgCls
        };

        new VToast(options).fire();
    }
}

window.copyText = function (targetId, message) {
    /* Get the field */
    var copyText = document.getElementById(targetId);
    
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.textContent);

    showSuccessAlert(message);
}

window.transformInToFormObject = function (model, form = null, namespace = '') {
    let formData = form || new FormData();

    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName]) continue;
        
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        
        if (model[propertyName] instanceof Date) {
            formData.append(formKey, model[propertyName].toISOString());
        } else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                transformInToFormObject(element, formData, tempFormKey);
            });
        } else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File)) {
            transformInToFormObject(model[propertyName], formData, formKey);
        } else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    
    return formData;
}

window.clearTextField = function (eleId) {
    document.getElementById(eleId).value = '';
}

window.select2Focus = function () {
    /* fix select2 auto-focus issue */
    $(document).on('select2:open', () => {
        let searchInput = $('.select2-container--open .select2-search__field').last().get(0);
        if (searchInput) {
            $(this).one('mouseup',()=>{
                setTimeout(()=>{
                    if ($(document.activeElement).closest('.select2').length) {
                        searchInput.focus();
                    }
                },0);
            });
        }
    });
}